import { Categories } from '../constants';
import { RoutinesNamesUtils } from '../RoutinesNamesUtils';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';

export class RiskManagementRisksNamesBase {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    const categoryFilter = filters.find(item =>
      [Categories.HUMAN_BASED_RISK, Categories.MISCONFIGURATION].includes(item.category)
    );
    if (!categoryFilter) {
      throw new Error('Unknown category');
    }

    const items = RoutinesNamesUtils.getFilteredTexts(searchString, categoryFilter.category);
    items.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

    return items.slice(limit * (page - 1), limit * page).map(item => {
      return {
        value: item.value,
      };
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response): ComplexSuggestedItem[] {
    return response;
  }

  /**
   *
   * @param value
   * @protected
   */
  static getLabelsCallback(value): string {
    const routinesTranslations = Application.modules.riskManagement.controller.helpers.routinesTranslations;
    const routinesNameDictionary = routinesTranslations.getDictionary('short_name');

    return routinesNameDictionary[value];
  }
}
